import { Instance, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { AdminGameService } from '@services/adminGameService';
import { LanguageService } from '@services/languageService';
import { initTable } from '@utils/collectionSetup';
import { AdminController } from './adminController';

export class AdminGamesIndexController extends AdminController {
    static readonly inject = [
        'instances',
        'adminGameService',
        'languageService',
    ] as const;

    private openSeasonId: string;
    private table!: Table;

    constructor(
        instances: Instance,
        private adminGameService: AdminGameService,
        private languageService: LanguageService,
    ) {
        super(instances);

        this.openSeasonId = this.state.getParam('openSeasonId');
    }

    protected override _initToolbarButtons(): void {
        this.helper.iconButton('.btn-admin-index', this.dom, () => {
            this.state.goBack('admin.index');
        });

        this.helper.fabButton('.btn-games-new', this.dom, () => {
            this.adminGameService
                .newDialogByOpenSeason(this.openSeasonId)
                .then(() => {
                    this._drawContent();
                });
        });
    }

    protected override _initTable(): void {
        this.table = initTable(
            this.table,
            this.dom,
            'table',
            this.adminGameService,
            {
                entityKey: 'games',
                fetchData: (params) =>
                    this.adminGameService.getAllByOpenSeason(
                        this.openSeasonId,
                        params,
                    ),
                extraParams: (params) => {
                    params.set('query', this.query);
                },
            },
            [
                {
                    style: () => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                        ];
                    },
                    click: (game) => {
                        this.adminGameService
                            .editDialog(game, '/admin/')
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ],
        )!;
    }
}

export const adminGamesIndexController = app.controller(
    'adminGamesIndexController',
    AdminGamesIndexController,
);
